import { IWindow } from '@luggagehero/shared/interfaces';

export class WindowPlatformService implements IWindow {
  public Intercom = {} as (event: string, ...args: unknown[]) => unknown;
  public intercomSettings: unknown = {};
  public onresize: unknown = {};
  public ontouchstart: unknown = {};
  public onmsgesturechange: unknown = {};
  public navigator = {} as Navigator;
  public top: { location: { href: string } } = { location: { href: '' } };
  public location = {} as Location;
  public localStorage: unknown;
  // Inert defaults rather than uninitialised (`!`): on the server this class IS the window
  // stand-in (provideBookingStack hands back `new WindowPlatformService()` under SSR), and
  // consumers like SharedWindowService.currentWindowSize read `screen.availWidth` / `innerWidth`
  // at construction. Leaving these undefined threw during prerender (AM-5037). On the browser the
  // real `window` is injected instead, so these defaults never apply there.
  public innerWidth = 0;
  public innerHeight = 0;
  public screen: { availWidth: number; availHeight: number } = { availWidth: 0, availHeight: 0 };
  public scrollX = 0;
  public scrollY = 0;
  public document: {
    body: { scrollHeight: number };
  } = { body: { scrollHeight: 0 } };
  public currentUrl = '';
  public previousUrl = '';
  public readonly closed: boolean = false;

  public focus(): void {
    void 0;
  }

  public scroll(_x: number, _y: number) {
    void 0;
  }

  public alert(_msg: unknown, _title?: unknown) {
    void 0;
  }
  public confirm(_msg: unknown): unknown {
    return null;
  }

  public setTimeout(_handler: (...args: unknown[]) => void, _timeout?: number): number {
    return 0;
  }

  public clearTimeout(_timeoutId: number) {
    void 0;
  }

  public setInterval(_handler: (...args: unknown[]) => void, _ms?: number, ..._args: unknown[]): number {
    return 0;
  }

  public clearInterval(_intervalId: number) {
    void 0;
  }

  public open(_url?: string, _target?: string, _features?: string, _replace?: boolean): IWindow | null {
    return null;
  }

  public print(): void {
    void 0;
  }

  public back(): void {
    void 0;
  }
  public forward(): void {
    void 0;
  }

  // ...You can expand support for more window methods as you need them here...
}
